<template>
  <generic-modal :title="$t('assign order')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('work order')"
            :placeholder="$t('select one')"
            url="/work_order/catalog"
            :display_text="(item) => item.name + ' - ' + item.order_id"
            value_field="order_id"
            :is_multiple="false"
            @selected="set_work_order"
            ref="work_order_dropdown"
          />
        </div>
      </div>
    </div>
    <div>
      <table class="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("size") }}</th>
            <th>{{ $t("quantity") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in summary" :key="item.product_id">
            <td>{{ item.product }}</td>
            <td>{{ item.size }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  post,
  get,
  generate_error_message_text,
  format_date,
  download,
  api_host,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "AssignOrderModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      api_host,
      mode: "create",
      order_items: [],
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.work_order_id;
    },
    summary() {
      let v = this;
      let grps = groupBy(v.order_items, (item) => {
        let obj = {
          product_id: item.product_id,
          size: item.size,
          product: item.product.name,
        };
        return JSON.stringify(obj);
      });
      let arr = Object.keys(grps)
        .map((key) => {
          let obj = JSON.parse(key);
          let items = grps[key];
          let total = items.reduce((acc, item) => {
            return acc + Number(item.quantity);
          }, 0);
          return {
            ...obj,
            total,
          };
        })
        .sort((a, b) => {
          return a.product.localeCompare(b.product);
        });
      return arr;
    },
  },
  methods: {
    format_currency,
    format_date,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(tailoring_order) {
      let v = this;
      v.set_initial_state();
      v.meta.tailoring_order_id = tailoring_order.order_id;
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(tailoring_order) {
      let v = this;
      // console.log("tailoring_order", tailoring_order);
      v.set_initial_state();
      v.mode = "edit";
      if (tailoring_order.order_id) {
        v.meta.tailoring_order_id = tailoring_order.order_id;
      }
      if (
        tailoring_order.work_order_item &&
        tailoring_order.work_order_item.order_id
      ) {
        v.$refs.work_order_dropdown.set_value(
          tailoring_order.work_order_item.order_id
        );
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      if (v.mode === "edit") {
        post("/tailoring_order/assign", data)
          .then((response) => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/tailoring_order/assign", data)
          .then((response) => {
            v.$emit("success");
            v.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.mode = "create";
      v.error = "";
      v.order_items = [];
      v.$refs.work_order_dropdown.clear();
    },
    set_work_order(work_order) {
      let v = this;
      if (work_order && work_order.uuid) {
        // console.log("work_order", work_order);
        v.meta.work_order_id = work_order.order_id;
        get("/work_order/summary/order", { uuid: work_order.uuid })
          .then((response) => {
            v.order_items = response;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
